import supportTypeEnum from '../supportTypeEnum'

export default function donationTypeValidator(donationFor) {
  return donationFor !== supportTypeEnum.NONE
}